import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useAppSelector } from "@store/hooks";
import reactLogo from "@assets/logos/react.svg";
import reduxLogo from "@assets/logos/redux.svg";
import typescriptLogo from "@assets/logos/typescript.svg";
import javascriptLogo from "@assets/logos/javascript.svg";
import leadershipLogo from "@assets/logos/leadership.svg";
const SkillsContainer = styled.div `
  display: block;
  width: 100%;
  padding-top: 28px;
`;
const SkillsTitle = styled.h3 `
  font-size: 1.7em;
  margin-bottom: 30px;
  color: #22334a;
`;
const SkillItem = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 24px;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
`;
const SkillRow = styled.div `
  display: flex;
  align-items: center;
`;
const SkillLabel = styled.span `
  width: 160px;
  display: flex;
  align-items: center;
`;
const SkillBar = styled.div `
  height: 8px;
  border-radius: 6px;
  flex: 1;
  margin-left: 12px;
  position: relative;
  min-width: 180px;
  max-width: 220px;
  transition: background 0.3s;
  background: #eee;

  &::after {
    content: "";
    display: block;
    height: 100%;
    background: #ffce3c;
    border-radius: 6px;
    transition: width 2.5s cubic-bezier(0.4, 1, 0.6, 1);
    width: ${(props) => (props.$isAnimated ? `${props.$percentage}%` : "0")};
    opacity: 1;
    position: relative;
    z-index: 2;
  }
`;
const Years = styled.div `
  margin-bottom: 6px;
  margin-top: 0;
  font-size: 0.85rem;
  color: #888;
  font-weight: 400;
  background: none;
  padding: 0;
  border-radius: 0;
  z-index: 3;
  text-align: center;
  position: absolute;
  top: -22px;
  left: ${(props) => Math.min(props.$percentage - 8, 85)}%;
  transform: translateX(-50%);
  min-width: 35px;
`;
const Skills = () => {
    const skills = useAppSelector((state) => state.portfolio.skills);
    const [isAnimated, setIsAnimated] = useState(false);
    const skillsRef = useRef(null);
    useEffect(() => {
        const handleScroll = () => {
            if (skillsRef.current) {
                const rect = skillsRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                if (rect.top < windowHeight - 80 && !isAnimated) {
                    setIsAnimated(true);
                }
                else if (rect.top >= windowHeight - 80 && isAnimated) {
                    setIsAnimated(false);
                }
            }
        };
        // Initial check
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isAnimated]);
    const getSkillIcon = (skillName) => {
        switch (skillName.toLowerCase()) {
            case "react":
                return reactLogo;
            case "react native":
                return reactLogo; // Using React logo for React Native
            case "redux":
                return reduxLogo;
            case "typescript":
                return typescriptLogo;
            case "javascript":
                return javascriptLogo;
            case "leadership":
                return leadershipLogo;
            default:
                return leadershipLogo; // Default fallback
        }
    };
    // Calculate percentage dynamically based on years vs total
    const calculatePercentage = (years, total) => {
        return Math.min((years / total) * 100, 100);
    };
    return (_jsxs(SkillsContainer, { ref: skillsRef, children: [_jsx(SkillsTitle, { children: "Skills" }), skills.map((skill, index) => (_jsxs(SkillItem, { children: [_jsx(SkillRow, { children: _jsxs(SkillLabel, { children: [_jsx("img", { src: getSkillIcon(skill.name), alt: `${skill.name} icon`, width: "22", height: "22", style: { marginRight: "8px" } }), skill.name] }) }), _jsx(SkillBar, { "$isAnimated": isAnimated, "$percentage": calculatePercentage(skill.years, skill.total), "$index": index, children: _jsxs(Years, { "$percentage": calculatePercentage(skill.years, skill.total), children: [skill.years, " yrs"] }) })] }, skill.name)))] }));
};
export default Skills;
